import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboNombreGrupoVerraco`, method: 'GET', body: null, token: token})
}
